import React from 'react';
import PropTypes from 'prop-types';

// Utilities
import { getImageUrl } from '../../../util/imageHelper';
import { ptToPx } from '../../../util';

// Styles
import './ImageLayer.less';

function ImageLayer(props) {
  const { imageElement, isFlipped, isFoldable, showPlaceholderImage } = props;
  // Set a default for offset and reset to 0 if height is already half or less or reset to half 0f height
  // if element is full height. This is only for thank you cards
  let yContainerOffSet = imageElement.y;
  if (isFoldable) {
    if (imageElement.height <= imageElement.y) {
      yContainerOffSet = 0;
    } else if (imageElement.height > imageElement.y) {
      yContainerOffSet = imageElement.y / 2;
    }
  }

  const imageLayerStyles = {
    left: `${Math.round(ptToPx(imageElement.x))}px`,
    top: `${Math.round(ptToPx(yContainerOffSet))}px`,
    width: `${Math.round(ptToPx(imageElement.width))}px`,
    height: `${Math.round(ptToPx(imageElement.height))}px`,
    zIndex: imageElement.layer,
    // prevent pointer events on images so that hoverstate isn't blocked on
    // elements that have image overlapping them
    pointerEvents: 'none',
  };

  // Set a default of 0 and reset to half if full height or recalculate y position minus half (315)
  // we do nothing if we are half already (y position === height). This is only for thank you cards
  let yPreviewOffSet = 0;
  if (isFoldable) {
    if (imageElement.height > imageElement.y) {
      yPreviewOffSet = 0 - imageElement.height / 2;
    } else if (imageElement.height < imageElement.y) {
      yPreviewOffSet = imageElement.y - 315;
    }
  }
  const imagePreviewStyles = {
    position: 'absolute',
    top: `${yPreviewOffSet}pt`,
    left: 0,
    // If isFlipped comes as true we need to flip the image upside down as if you were seeing it folded from the back
    transform: `rotate(${isFlipped ? '180deg' : '0'})`,
  };

  if (imageElement.image_id) {
    // if there is a photoUUID we want to render the actual image - this is the case for most images
    return (
      <div
        className={`image-layer-container${
          imageElement.customizable ? ' image-layer-customizable' : ''
        }`}
        style={imageLayerStyles}
      >
        <img
          className="image-layer-preview image-layer-preview--no-hover"
          style={imagePreviewStyles}
          src={`${getImageUrl(imageElement.image_id)}`}
          alt="init Customizable Pic"
          draggable="false"
        />
      </div>
    );
  }
  if (showPlaceholderImage) {
    // showPlaceholderImage will be true when there is a customizable image that has been deleted
    // but the user toggles 'add photo' to true, this will render a blue background with the
    // dimensions/position the same as the image element
    return (
      <div
        className={`image-layer-container ${
          imageElement.customizable ? 'image-layer-customizable' : ''
        }`}
        style={imageLayerStyles}
      >
        <span className="placeholder-image" />
      </div>
    );
  }
  return null;
}

ImageLayer.propTypes = {
  imageElement: PropTypes.shape({}),
  isFlipped: PropTypes.bool,
  isFoldable: PropTypes.bool,
  showPlaceholderImage: PropTypes.bool,
};

export default ImageLayer;



// WEBPACK FOOTER //
// ./src/cards/components/Customization/Preview/ImageLayer.jsx